import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { svgIconList } from '@shared/svg-icon-list';

/**
 * Port of template-02's ApiErrorInterceptor generic branch, scoped to `POST /withdraw`.
 * qply has no global API-error dialog, so the backend's rejection (e.g. "The deposit turnover has
 * not been met yet") would otherwise never reach the member. The error is rethrown untouched so
 * the withdraw page's own handler still runs.
 */
export const withdrawErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService);

  if (req.method !== 'POST' || !/\/withdraw$/.test(req.url.split('?')[0])) {
    return next(req);
  }

  return next(req).pipe(
    catchError((e: HttpErrorResponse) => {
      const stack = e.error?.message;
      const items = (Array.isArray(stack) ? stack : [stack]).filter((m: any) => !!m);
      if (items.length === 0) {
        items.push('Something went wrong. Please try again.');
      }

      Swal.fire({
        html: '<div class="alert-svg">' + svgIconList.alertIcon + '</div>' +
          '<div class="text-center m-t-30"><ul>' +
          items.map((m: string) => `<li>${translateService.instant(m)}</li>`).join('') +
          '</ul></div>',
        showCloseButton: true,
      });

      return throwError(() => e);
    }),
  );
};
